import { render, staticRenderFns } from "./PaymentDiscountGoodsList.vue?vue&type=template&id=0ae90404&scoped=true&lang=pug&"
import script from "./PaymentDiscountGoodsList.vue?vue&type=script&lang=ts&"
export * from "./PaymentDiscountGoodsList.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentDiscountGoodsList.vue?vue&type=style&index=0&id=0ae90404&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae90404",
  null
  
)

export default component.exports